module.exports = __webpack_public_path__ + "img/marker_incident_office.0ecf11a.svg";